export default __webpack_public_path__ + "static/media/ER11.4f96d1de.png";